import { createContext, useContext } from "react";
import type { SkyTone } from "@/data/sky";

export const SKY_TONE_STORAGE_KEY = "zesrin.sky-tone";
export const SKY_TONES: readonly SkyTone[] = ["sunrise", "sun", "sunset", "moon"];

export interface SkyThemeValue {
  tone: SkyTone;
  setTone: (tone: SkyTone) => void;
}

export const SkyThemeContext = createContext<SkyThemeValue | null>(null);

export function isSkyTone(value: unknown): value is SkyTone {
  return typeof value === "string" && SKY_TONES.includes(value as SkyTone);
}

export function useSkyTheme() {
  const value = useContext(SkyThemeContext);
  return value ?? { tone: "sun" as SkyTone, setTone: () => undefined };
}
